require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-market-basket-analysis.json") })
        }
      }, "path---posts-market-basket-analysis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-market-basket-analysis!./.cache/json/posts-market-basket-analysis.json
// module id = 392
// module chunks = 231608221292675